import React, { useState, Suspense, lazy } from 'react';
import { StarIcon, CheckCircleIcon } from 'lucide-react';
// First row testimonials with images - all 50+ years old with unique testimonials
const firstRowTestimonials = [{
  name: 'Robert, 58',
  image: 'https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
  text: "I thought my thinning hair was just part of aging. After 3 months with this formula, I'm seeing regrowth I haven't had in 15 years. My confidence is back!"
}, {
  name: 'Michael, 62',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
  text: "I've been losing hair since my 40s. This is the first product that actually reversed it. My barber noticed the difference before I did. Absolutely worth it."
}, {
  name: 'David, 54',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
  text: 'After decades of trying everything, I was ready to give up. This oil changed everything. My hair feels thicker and healthier than it has in 20 years.'
}, {
  name: 'James, 67',
  image: 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
  text: "I'm seeing new growth where I thought it was impossible! My wife says I look 10 years younger. This formula works when you think nothing will. Don't wait like I did."
}];
// Unique testimonials for the second row (without images)
const secondRowTestimonials = [{
  name: 'William, 59',
  text: "My crown was completely bald for years. Now I'm seeing baby hairs filling in. I never thought this was possible. This product is remarkable."
}, {
  name: 'Richard, 61',
  text: "I spent thousands on treatments that didn't work. This affordable oil delivered better results in 2 months than everything else combined. Wish I'd found it sooner."
}, {
  name: 'Thomas, 56',
  text: "The shedding stopped within weeks, and now I'm seeing actual regrowth. My adult kids can't believe the difference. This is the real deal."
}, {
  name: 'Charles, 63',
  text: 'I was embarrassed to go out without a hat. Now I feel confident again. The thickness and volume are back. This formula gave me my life back.'
}];
// Lazy loaded additional testimonials component
const AdditionalTestimonials = lazy(() => Promise.resolve({
  default: ({
    maleNames,
    additionalTestimonials
  }) => {
    return <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-10" data-id="element-182">
          {/* Additional testimonials with images */}
          {additionalTestimonials.map((testimonial, i) => <div key={i} className="border border-gray-200 p-4 rounded-lg" data-id="element-183">
              <div className="flex mb-2" data-id="element-184">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="text-yellow-400 fill-yellow-400" size={16} data-id="element-185" />)}
              </div>
              <div className="flex items-center mb-3" data-id="element-186">
                <div className="w-10 h-10 rounded-full overflow-hidden mr-2" data-id="element-187">
                  <img src={testimonial.image} alt={`${testimonial.name} testimonial`} className="w-full h-full object-cover" loading="lazy" width="40" height="40" decoding="async" data-id="element-188" />
                </div>
                <div data-id="element-189">
                  <p className="text-xs font-bold flex items-center" data-id="element-190">
                    {testimonial.name}
                    <span className="ml-1 flex items-center text-green-600" data-id="element-191">
                      <CheckCircleIcon size={12} className="mr-1" data-id="element-192" /> Verified
                    </span>
                  </p>
                </div>
              </div>
              <p className="text-sm mb-2" data-id="element-193">{testimonial.text}</p>
            </div>)}
          {/* Additional testimonials without images */}
          {maleNames.slice(8, 12).map((testimonial, i) => <div key={i + 8} className="border border-gray-200 p-4 rounded-lg" data-id="element-194">
              <div className="flex mb-2" data-id="element-195">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="text-yellow-400 fill-yellow-400" size={16} data-id="element-196" />)}
              </div>
              <p className="text-xs font-bold flex items-center mb-2" data-id="element-197">
                {testimonial.name}
                <span className="ml-1 flex items-center text-green-600" data-id="element-198">
                  <CheckCircleIcon size={12} className="mr-1" data-id="element-199" /> Verified
                </span>
              </p>
              <p className="text-sm mb-2" data-id="element-200">{testimonial.text}</p>
            </div>)}
        </div>;
  }
}));
export function MoreTestimonials() {
  const [showMoreTestimonials, setShowMoreTestimonials] = useState(false);
  const scrollToProductOptions = () => {
    document.getElementById('product-options')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  // Additional testimonials with images for "Show More" section
  const additionalTestimonialsWithImages = [{
    name: 'Joseph, 65',
    image: 'https://images.unsplash.com/photo-1599566150163-29194dcaad36?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
    text: "After retirement, I wanted to look my best. This oil delivered results I didn't think were possible. My hair is fuller and healthier than it's been in years."
  }, {
    name: 'Daniel, 57',
    image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
    text: "I've tried prescriptions, supplements, everything. This natural formula is the only thing that worked. The regrowth is real and it keeps improving."
  }, {
    name: 'Paul, 60',
    image: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
    text: "My colleagues thought I got a transplant! No, just this amazing oil. I have more hair now than I did 10 years ago. It's never too late to start."
  }, {
    name: 'Steven, 55',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
    text: 'The bald spot on my crown is filling in nicely. My wife is amazed. This is the first product that actually does what it promises. Highly recommend.'
  }];
  // Additional testimonials without images for "Show More" section
  const additionalTestimonialsNoImages = [{
    name: 'Mark, 64',
    text: "I was losing hope until I found this. The hair loss stopped completely, and now I'm seeing real regrowth. I feel like I've turned back the clock."
  }, {
    name: 'Donald, 68',
    text: "This formula works! My hairline is coming back and the thinning areas are filling in. I wish I'd known about this years ago."
  }, {
    name: 'Kenneth, 52',
    text: 'After 10 years of progressive hair loss, I finally found something that works. The results are visible and my confidence is restored. Thank you!'
  }, {
    name: 'Anthony, 66',
    text: "I thought hair regrowth was impossible for me. This oil proved me wrong. My barber can't believe the transformation. It's never too late!"
  }];
  return <section className="w-full py-12 bg-white px-4" data-id="element-201">
      <div className="max-w-6xl mx-auto" data-id="element-202">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-10" data-id="element-203">
          More Success Stories
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-10" data-id="element-204">
          {/* First row with images */}
          {firstRowTestimonials.map((testimonial, i) => <div key={i} className="border border-gray-200 p-4 rounded-lg" data-id="element-205">
              <div className="flex mb-2" data-id="element-206">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="text-yellow-400 fill-yellow-400" size={16} data-id="element-207" />)}
              </div>
              <div className="flex items-center mb-3" data-id="element-208">
                <div className="w-10 h-10 rounded-full overflow-hidden mr-2" data-id="element-209">
                  <img src={testimonial.image} alt={`${testimonial.name} testimonial`} className="w-full h-full object-cover" loading="lazy" width="40" height="40" decoding="async" data-id="element-210" />
                </div>
                <div data-id="element-211">
                  <p className="text-xs font-bold flex items-center" data-id="element-212">
                    {testimonial.name}
                    <span className="ml-1 flex items-center text-green-600" data-id="element-213">
                      <CheckCircleIcon size={12} className="mr-1" data-id="element-214" /> Verified
                    </span>
                  </p>
                </div>
              </div>
              <p className="text-sm mb-2" data-id="element-215">{testimonial.text}</p>
            </div>)}
          {/* Second row without images */}
          {secondRowTestimonials.map((testimonial, i) => <div key={i + 4} className="border border-gray-200 p-4 rounded-lg" data-id="element-216">
              <div className="flex mb-2" data-id="element-217">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="text-yellow-400 fill-yellow-400" size={16} data-id="element-218" />)}
              </div>
              <p className="text-xs font-bold flex items-center mb-2" data-id="element-219">
                {testimonial.name}
                <span className="ml-1 flex items-center text-green-600" data-id="element-220">
                  <CheckCircleIcon size={12} className="mr-1" data-id="element-221" /> Verified
                </span>
              </p>
              <p className="text-sm mb-2" data-id="element-222">{testimonial.text}</p>
            </div>)}
        </div>
        {/* Show More Button */}
        {!showMoreTestimonials && <div className="text-center mb-10" data-id="element-223">
            <button className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-full" onClick={() => setShowMoreTestimonials(true)} data-id="element-224">
              Show More
            </button>
          </div>}
        {/* Additional testimonials that show when button is clicked */}
        {showMoreTestimonials && <Suspense fallback={<div className="h-40 w-full bg-gray-100 animate-pulse rounded-lg" data-id="element-226"></div>} data-id="element-225">
            <AdditionalTestimonials maleNames={additionalTestimonialsNoImages} additionalTestimonials={additionalTestimonialsWithImages} data-id="element-227" />
          </Suspense>}
        {/* Trusted By Section */}
        <div className="border border-gray-200 rounded-lg p-6 mb-10" data-id="element-228">
          <div className="flex flex-col md:flex-row items-center" data-id="element-229">
            <div className="md:w-3/5 mb-6 md:mb-0 pr-0 md:pr-8" data-id="element-230">
              <h3 className="text-xl font-bold mb-3" data-id="element-231">
                Trusted by 74,000+ Men Fighting Hair Loss
              </h3>
              <p className="text-lg italic mb-3" data-id="element-232">
                "Our Indonesian formula has revolutionized hair growth by
                addressing the root causes of baldness that other solutions
                miss"
              </p>
              <p className="text-sm text-gray-600" data-id="element-233">
                Dr. John Nash, Hair Loss Specialist and Formulator
              </p>
            </div>
            <div className="md:w-2/5" data-id="element-234">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6vLmTv3pCETysP9mSkHdPQ/ChatGPT_Image_20_%CE%A3%CE%B5%CF%80_2025%2C_07_33_48_%CE%BC.%CE%BC..webp" alt="Doctor Approved Hair Loss Solution" className="rounded-lg max-w-full h-auto" loading="lazy" width="400" height="300" data-id="element-235" />
            </div>
          </div>
          <div className="mt-8" data-id="element-236">
            <p className="text-center font-bold mb-4" data-id="element-237">As seen on</p>
            <div className="grid grid-cols-1 gap-4 items-center justify-items-center" data-id="element-238">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hWvqJgLpYTQEDFVanWBZKh/1744811807-logo_%281%29.webp" alt="Media logos including NBC, ABC, CBS, FOX NEWS, DIGITAL JOURNAL, USA TODAY" className="h-auto max-w-full" loading="lazy" width="800" height="100" data-id="element-239" />
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-240">
          <h3 className="text-xl font-bold mb-6" data-id="element-241">
            Your Choice: Keep Losing Hair or Take Action Today
          </h3>
          <button className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-8 rounded-full mb-6" onClick={scrollToProductOptions} data-id="element-242">
            CLAIM MY HAIR GROWTH OIL 3.0 NOW
          </button>
          <p className="text-sm text-gray-600" data-id="element-243">
            *These statements have not been evaluated by the FDA. This product
            is not intended to diagnose, treat, cure or prevent any disease.
            Individual results may vary.
          </p>
        </div>
      </div>
    </section>;
}
export default {
  MoreTestimonials
};